import type { GetStatusResponse } from '@salescore/agent-contract'
import { Effect } from 'effect'
import { z } from 'zod'

import { type AgentApi, parseJsonResponse } from './agentApi'

// loading は読み終えるまで。読めなかったときは disabled にし、使えると扱わない
export type AgentStatus = 'loading' | 'enabled' | 'disabled'

// 画面と BE の共有の型（@salescore/agent-contract）には status の応答の型しかないので、スキーマをここに置き、satisfies で共有の型に合わせる。
// agent-contract に status の zod のスキーマが入ったら、このスキーマを消してそれを使い、doc/impl/agent/DESIGN.md の「画面」の節のこのスキーマの記述も消す
const getStatusResponseSchema = z.object({ enabled: z.boolean() }) satisfies z.ZodType<GetStatusResponse>

/**
 * GET /api/agent/gateway/status を読み、組織と利用者でエージェント機能を使えるかを返す。判定は BE に任せ、画面では同じ条件を持たない。
 * 応答の形が違うときと、API が失敗したときは disabled を返す
 */
export const fetchAgentStatus = (api: AgentApi): Effect.Effect<'enabled' | 'disabled'> =>
  api('/api/agent/gateway/status', { method: 'GET' }).pipe(
    Effect.flatMap((response) => parseJsonResponse(response, getStatusResponseSchema)),
    Effect.map(({ enabled }) => (enabled ? 'enabled' : 'disabled')),
    Effect.catchAll(() => Effect.succeed('disabled' as const)),
  )
